import React from "react";
import { GoalTypeShape } from "../interfaces/classTypes";

let includedGoalTypes = [];
export class GoalType {
  public handle: string;
  public id: number;
  public label: string;
  public name: string;

  constructor(data: GoalTypeShape) {
    this.handle = data.handle;
    this.id = data.id;
    this.label = data.label;
    this.name = data.name;
    this.save();
  }
  save() {
    includedGoalTypes.push(this);
  }
  static includedGoalTypes() {
    return includedGoalTypes;
  }
}
